import React, { useReducer } from 'react';
import LoRaContext from './loraContext';
import LoRaReducer from './loraReducer';

import { 
    OBTENER_APLICATIONS,
    OBTENER_DEVICE_PROFILES,
    OBTENER_DEVICE_PROFILE    
} from 'types/context';
const LoRaState = props => {
    const initialState = {
        aplications : [],
        deviceProfiles : [],
        deviceProfile:{},     
    }
    let config = {
        headers: {
          "Authorization":`Bearer ${ process.env.REACT_APP_LORA_TOKEN }`,
          "content-type":"application/json",
        }
    };    
    
    const [ state, dispatch ] = useReducer(LoRaReducer, initialState);
    
    const clearAll = () =>{
        dispatch({
            type: OBTENER_APLICATIONS,
            payload:[]
        })
        dispatch({
            type: OBTENER_DEVICE_PROFILE,
            payload:null
        })
        dispatch({
            type: OBTENER_DEVICE_PROFILES,
            payload:[]
        })
    }
    
    const obtenerAplications = async () => {
        try {
            let resultado;  
            await fetch(`/applications?limit=1000`, config).then(response => response.json().then(data =>{
                resultado = data
                dispatch({
                    type: OBTENER_APLICATIONS,
                    payload: resultado.result?resultado.result:[]
                })
                return resultado.result?resultado.result:[]                
            }));          
        } catch (error) {
            console.log(error)
            return error
           /* const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }  */          
        }
    }
    const obtenerDeviceProfiles = async () => {
        try {           
            let resultado;                     
            await fetch(`/device-profiles?limit=1000`, config).then(response => response.json().then(data =>{
                resultado = data
                dispatch({
                    type: OBTENER_DEVICE_PROFILES,
                    payload: resultado.result?resultado.result:[]
                })
                return resultado.result?resultado.result:[]                
            }));          
        } catch (error) {
            return error
            console.log(error)
           /* const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }  */       
        }
    }
    const obtenerDeviceProfile = async (device_profile_id) => {
        try {           
            let resultado;                     
            await fetch(`/device-profiles/${device_profile_id}`, config).then(response => response.json().then(data =>{
                resultado = data
                dispatch({
                    type: OBTENER_DEVICE_PROFILE,
                    payload: resultado.deviceProfile?resultado.deviceProfile:{}
                })
                return resultado.deviceProfile?resultado.deviceProfile:{}                
            })); 
            return resultado.deviceProfile?resultado.deviceProfile:{};         
        } catch (error) {
            return error
            console.log(error)
           /* const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }  */       
        }
    }
   

    // https://iotnetwork.pampa4.ar:8080/api/device-profiles/{device_profile.id}
    return(
        <LoRaContext.Provider
            value={{
                aplications: state.aplications,
                deviceProfiles: state.deviceProfiles,
                deviceProfile: state.deviceProfile,           
                obtenerAplications,                
                obtenerDeviceProfiles,
                obtenerDeviceProfile,
                clearAll
            }}
        >{props.children}

        </LoRaContext.Provider>
    )
}
export default LoRaState;
